type Props = { title: string; phase: string; description: string };

export function Placeholder({ title, phase, description }: Props) {
  return (
    <section>
      <h1>{title}</h1>
      <p className="phase">Arriving in {phase}.</p>
      <p>{description}</p>
      <style>{`.phase { color: var(--ac-grey-500); font-size: 14px; }`}</style>
    </section>
  );
}
